import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import Grafico from '../../../graphics/SetRangeWidthOfGauge';
import { Title, Container } from './styles';

const MeterGaugePlot: React.FC = () => {
  const data = useSelector((state: ApplicationState) => state.DashSla.data['percSla']);
  const percent = data ? Number((+data / 100).toFixed(2)) : 0;
  return (
    <Container>
      <Title>SLA Geral</Title>
      <div style={{ width: '100%' }}>
        <Grafico percent={percent} />
      </div>
    </Container>
  );
};

export default MeterGaugePlot;
